import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, finalize, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private httpClient: HttpClient) { }

  // getUrl(url?: string): string {
  //   const apiUrl: string = environment.api.url;
  //   return apiUrl + '/' + (url ? url.trim() : '');
  // }

  getUrl(endpoint?: string, base: 'main' | 'ekyc' = 'main'): string {
    const baseUrl =
      base === 'main'
        ? environment.api.url
        : environment.api.ekycUrls;

    return baseUrl + '/' + (endpoint ? endpoint.trim() : '');
  }
  
  filterOptions(options?: any): any {
    return options;
  }

  // get(url: string, options?: any): Observable<any> {
  //   const apiUrl = this.getUrl(url);
  //   const opt = this.filterOptions(options);
  //   return this.httpClient.get(apiUrl, opt).pipe(
  //     timeout(environment.api.timeout),
  //     map((response) => {
  //       return this.handleResponse(response);
  //     }),
  //     catchError((errors: HttpErrorResponse) => {
  //       return this.handleError(errors);
  //     }),
  //     finalize(() => {
  //       return this.handleComplete();
  //     })
  //   );
  // }
  get(url: string, options?: any, base: 'main' | 'ekyc' = 'main'): Observable<any> {
    const apiUrl = this.getUrl(url, base); // use selected base
    const opt = this.filterOptions(options);

    return this.httpClient.get(apiUrl, opt).pipe(
      timeout(environment.api.timeout),
      map((response) => this.handleResponse(response)),
      catchError((errors: HttpErrorResponse) => this.handleError(errors)),
      finalize(() => this.handleComplete())
    );
  }


  // post(url: string, body: any, options?: any): Observable<any> {
  //   const apiUrl = this.getUrl(url);
  //   const opt = this.filterOptions(options);
  //   return this.httpClient.post(apiUrl, body, opt).pipe(
  //     timeout(environment.api.timeout),
  //     map((response) => {
  //       return this.handleResponse(response);
  //     }),
  //     catchError((errors: HttpErrorResponse) => {
  //       return this.handleError(errors);
  //     }),
  //     finalize(() => {
  //       return this.handleComplete();
  //     })
  //   );
  // }

  post(url: string, body: any, options?: any, base: 'main' | 'ekyc' = 'main'): Observable<any> {
    const apiUrl = this.getUrl(url, base); // pass base type
    const opt = this.filterOptions(options);

    return this.httpClient.post(apiUrl, body, opt).pipe(
      timeout(environment.api.timeout),
      map(response => this.handleResponse(response)),
      catchError(error => this.handleError(error)),
      finalize(() => this.handleComplete())
    );
  }


  put(url: string, body: any, options?: any): Observable<any> {
    const apiUrl = this.getUrl(url);
    const opt = this.filterOptions(options);
    return this.httpClient.put(apiUrl, body, opt).pipe(
      timeout(environment.api.timeout),
      map((response) => {
        return this.handleResponse(response);
      }),
      catchError((errors: HttpErrorResponse) => {
        return this.handleError(errors);
      }),
      finalize(() => {
        return this.handleComplete();
      })
    );
  }

  delete(url: string, options?: any): Observable<any> {
    const apiUrl = this.getUrl(url);
    const opt = this.filterOptions(options);
    return this.httpClient.delete(apiUrl, opt).pipe(
      timeout(environment.api.timeout),
      map((response) => {
        return this.handleResponse(response);
      }),
      catchError((errors: HttpErrorResponse) => {
        return this.handleError(errors);
      }),
      finalize(() => {
        return this.handleComplete();
      })
    );
  }

  private handleResponse(response: any): Observable<any> {
    return response;
  }

  private handleError(errors: any): Observable<any> {
    throw errors;
  }

  private handleComplete(body?: any): any {
    return body;
  }
}
